/**
 * Category mapping between Tabitto and Mekke apps
 *
 * Tabitto categories (5): sightseeing, food, activity, transport, accommodation
 * Mekke categories (7): restaurant, cafe, landmark, park, museum, shop, other
 */

import type { MekkeSpotCategory } from "../types/api/mekke";

// Tabitto spot categories
export type TabittoSpotCategory =
  | "sightseeing"
  | "food"
  | "activity"
  | "transport"
  | "accommodation";

// Mapping: Tabitto -> Mekke
const tabittoToMekkeMap: Record<TabittoSpotCategory, MekkeSpotCategory> = {
  sightseeing: "landmark",
  food: "restaurant",
  activity: "park",
  transport: "other",
  accommodation: "other",
};

// Mapping: Mekke -> Tabitto
const mekkeToTabittoMap: Record<MekkeSpotCategory, TabittoSpotCategory> = {
  restaurant: "food",
  cafe: "food",
  landmark: "sightseeing",
  park: "activity",
  museum: "sightseeing",
  shop: "activity",
  other: "sightseeing",
};

/**
 * Convert a Tabitto spot category to Mekke spot category
 */
export function mapTabittoToMekkeCategory(category: string): MekkeSpotCategory {
  const mapped = tabittoToMekkeMap[category as TabittoSpotCategory];
  return mapped ?? "other";
}

/**
 * Convert a Mekke spot category to Tabitto spot category
 */
export function mapMekkeToTabittoCategory(category: string): TabittoSpotCategory {
  const mapped = mekkeToTabittoMap[category as MekkeSpotCategory];
  return mapped ?? "sightseeing";
}
